<template>
    <div>
        <vue-bootstrap-typeahead
            v-show="!disabled"
            ref="searchInput"
            v-model="search"
            :data="data"
            :placeholder="placeholder"
            :minMatchingChars="minMatchingChars"
            @input="inputTypeahead($event)"
            @hit="inputTypeahead($event)"
        />
        <b-form-input
            v-show="disabled"
            :value="search"
            :placeholder="placeholder"
            :disabled="disabled"
        />
    </div>
</template>

<script>
import _ from 'underscore';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';

const searchDelay = 500;

export default {
    name: 'CustomTypeahead',
    components: { VueBootstrapTypeahead },
    props: {
        value: {
            type: [String, Number],
            'default': null,
        },

        minMatchingChars: {
            type: Number,
            'default': 3,
        },

        placeholder: {
            type: String,
            'default': '',
        },

        src: {
            type: String,
            'default': '',
        },

        disabled: {
            type: Boolean,
            'default': false,
        },
    },

    data() {
        return {
            current: this.value,
            data: [],
            search: '',
        };
    },

    methods: {
        inputTypeahead: function(event) { // Обработка события ввода данных в строках typeahead
            this.$emit('input', event);
            return true;
        },

        getSearch: function(type) { // Запрос на получение списка магазинов, их адресов или городов
            if (Object.keys(this.data).length > 0) {
                return this.data;
            }
            this.axios.get(this.src)
                .then((response) => {
                    this.data = Object.values(response.data);
                });
        },
    },

    watch: {
        current: function() {
            this.$emit('input', this.current);
        },

        value: function() {
            this.$refs.searchInput.handleInput(this.value);
            this.current = this.value;
        },

        search: _.debounce(function() {
            this.getSearch();
        }, searchDelay),
    },

    mounted() {
        this.$refs.searchInput.handleInput(this.value);
    },
};
</script>